import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function LoginPage() {
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    const trimmedToken = token.trim();
    if (!trimmedToken) {
      setError('Please enter an API token');
      setIsLoading(false);
      return;
    }

    const success = await login(trimmedToken);

    if (success) {
      navigate('/');
    } else {
      setError('Invalid API token. Please check and try again.');
    }

    setIsLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>FieldVoice</h1>
          <p>Web Dashboard</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="token">API Token</label>
            <input
              id="token"
              type="password"
              className="input"
              placeholder="Enter your API token"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              disabled={isLoading}
              autoFocus
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="button login-button" disabled={isLoading}>
            {isLoading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className="login-footer">
          <p>Need an API token? Contact your administrator.</p>
        </div>
      </div>
    </div>
  );
}
